import { useEffect } from "react"

// This could be done much better using more modern versions of React/Node
// for the time being we'll need to settle with this

const ScrollToTop = () => {

    useEffect(() => {
        setTimeout(function(){
            // scroll to top
            if (typeof window === "undefined") {
            // SSR
            } else {
                const currUrl = window.location.href;

                if(currUrl.indexOf('#') > 0) {
                    // Don't scroll the page
                }
                else {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth"
                    }); 
                }
            }
        }, 100);   
    })

}
export default ScrollToTop;